import { IncentivesPayoutRuleFragment } from 'generated/resources/graphql'

export type PayoutRuleSummary = {
  threshold: number | null
  cap: number | null
}

export const getPayoutRuleSummary = (rules: IncentivesPayoutRuleFragment[]): PayoutRuleSummary => {
  const cliffRule = rules.find((r) => r.rule === 'cliff')
  const linearRule = rules.find((r) => r.rule === 'linear')

  const threshold = cliffRule ? (cliffRule.rangeTo ?? null) : (linearRule?.rangeFrom ?? null)
  const cap = linearRule?.rangeTo ?? null

  return { threshold, cap }
}

export const buildPayoutRulesFromSummary = ({
  threshold,
  cap,
}: PayoutRuleSummary): IncentivesPayoutRuleFragment[] => {
  const rules: IncentivesPayoutRuleFragment[] = []

  if (threshold !== null) {
    rules.push({ rule: 'cliff', rangeFrom: 0, rangeTo: threshold, rate: 0 })
  }

  if (threshold !== null || cap !== null) {
    rules.push({ rule: 'linear', rangeFrom: threshold ?? 0, rangeTo: cap, rate: 1 })
  }

  return rules
}
